<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Descargar registros de aportes
                  </div> 
                </template> 
                <sw-tableget 
                    :filterShow="false"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_aportesdescargar"
                    dataRoute="'descargar'"
                    @filtrar="getFiltrar"
                    @save="saveForm"
                    @pdf="getPdf"
                    >                                      
                    <template v-slot:modal>
                      <sw-modalaportesdescargar 
                        v-if="openModal.modal.modal==='Descargar'"
                        @save="saveForm">
                      </sw-modalaportesdescargar>
                      <sw-modalanularaporte
                        v-if="openModal.modal.modal==='Anular'"
                        @save="saveForm">
                      </sw-modalanularaporte>
                    </template>   
                </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row>  
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalaportesdescargar from '@/components/modals/aportesDescargar.vue'
import SwModalanularaporte from '@/components/modals/anularAporte.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    SwModalaportesdescargar,
    'c-multiselect': Multiselect,
    SwModalanularaporte,
    
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
